export function videoDraggable(elementId) {
    const element = document.querySelector("#" + elementId + "") as HTMLDivElement;
    if (element && !element.classList.contains("element-draggable")) {
        initializeDraggable(element);
    }
    else {

        const iframeChat = document.querySelector("#" + elementId + " iframe") as HTMLDivElement;
        const positionX = iframeChat.getBoundingClientRect().left;
        const positionY = iframeChat.getBoundingClientRect().top;

        let offsetWidth = iframeChat.offsetWidth;
        let offsetHeight = iframeChat.offsetHeight;

        if (positionX < 10) {
            stopDragging(element);
            element.style.left = "20px";
        } else if (positionX > (window.innerWidth - offsetWidth - 20)) {
            stopDragging(element);
            element.style.left = (window.innerWidth - offsetWidth - 40) + "px";
        }        

        if (positionY < 0) {
            stopDragging(element);
            element.style.top =  "20px";
        } else if (positionY > window.innerHeight - offsetHeight) {
            stopDragging(element);
            element.style.top = (window.innerHeight - offsetHeight - 20) + "px";
        }

    }
}

export function chatDraggable(elementId) {
    const element = document.querySelector("#" + elementId + " div") as HTMLDivElement;
    if (element && !element.classList.contains("element-draggable")) {
        initializeDraggable(element);
    }
    else {
        const button = document.querySelector("#" + elementId + " div button") as HTMLDivElement;
        if (!button) return;
        const iframeChat = document.querySelector("#" + elementId + " iframe") as HTMLDivElement;
        const positionX = button.getBoundingClientRect().left;

        if (iframeChat) {

            let offsetWidth = iframeChat.offsetWidth;
            let offsetHeight = iframeChat.offsetHeight;

            //if (!element.hasAttribute("bloqX")) element.setAttribute("bloqX", "true");

            if (iframeChat.offsetWidth == 0 || iframeChat.offsetHeight == 0) {
                const elementdiv = document.querySelector("#" + elementId + " div div") as HTMLDivElement;
                offsetWidth = elementdiv.offsetWidth;
                offsetHeight = elementdiv.offsetHeight;
            }

            if (positionX < button.offsetWidth * 0.5) {
                stopDragging(element);
                element.style.left = button.offsetWidth + "px";
            } else if (positionX > (window.innerWidth - button.offsetWidth - offsetWidth - 20)) {
                stopDragging(element);
                element.style.left = (window.innerWidth - button.offsetWidth - offsetWidth) + "px";
            }

            if (element.getBoundingClientRect().top < button.offsetHeight) {
                stopDragging(element);
                element.style.top = button.offsetHeight + "px";
            } else if (button.getBoundingClientRect().bottom > window.innerHeight) {
                stopDragging(element);
                element.style.top = (window.innerHeight - offsetHeight - button.offsetHeight - 20) + "px";
            }
        }

        else {

            if (element.hasAttribute("bloqX")) element.removeAttribute("bloqX");

            const positionY = button.getBoundingClientRect().top;

            if (positionX < 0) {
                stopDragging(element);
                element.style.left = button.offsetWidth + "px";
            } else if (positionX > window.innerWidth - button.offsetWidth * 1.5) {
                stopDragging(element);
                element.style.left = (window.innerWidth - button.offsetWidth) + "px";
            }

            if (positionY < button.offsetHeight * 0.5) {
                stopDragging(element);
                element.style.top = button.offsetHeight * 0.5 + "px";
            } else if (positionY > window.innerHeight - button.offsetHeight) {
                stopDragging(element);
                element.style.top = (window.innerHeight - button.offsetHeight * 1.5) + "px";
            }
        }
    }
}

function stopDragging(element) {
    element.draggable && element.setAttribute("stopDragging", "true");
}

export function initializeDraggable(element) {
    element.dragging = false;
    let startX = 0;
    let startY = 0;
    let offsetX = 0;
    let offsetY = 0;

    element.classList.add("element-draggable");

    element.addEventListener("mousedown", onMouseDown);

    function onMouseDown(event) {
        // Evita que se realice la selección de texto en el elemento
        event.preventDefault();

        startX = event.clientX;
        startY = event.clientY;
        const rect = element.getBoundingClientRect();
        offsetX = startX - rect.left;
        offsetY = startY - rect.top;

        element.dragging = true;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    }

    function onMouseUp() {

        element.dragging = false;

        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
    }

    function onMouseMove(event) {

        if (element.dragging) {
            if (element.hasAttribute("stopDragging")) {
                element.dragging = false;
                element.removeAttribute("stopDragging");
                return;
            }
            const style = element.hasAttribute("bloqX") ? "bloqX" : element.hasAttribute("bloqY") ? "bloqY" : null;
            const x = event.clientX - offsetX;
            const y = event.clientY - offsetY;
            if (style === "bloqX" || style === null) element.style.left = x + "px";
            if (style === "bloqY" || style === null) element.style.top = y + "px";
        }
    }
}

